import { createFileRoute, notFound } from "@tanstack/react-router";
import shopStyles from "../styles/shop.css?url";
import { ShopCollection } from "../components/shop/shop-collection";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadShopCollection } from "../server/shop";

/** One merch collection (/merch/collections/:slug): always native. */
export const Route = createFileRoute("/merch/collections/$slug")({
  loader: async ({ params }) => {
    const collection = await loadShopCollection({ data: params.slug });
    if (!collection) throw notFound();
    return collection;
  },
  head: ({ matches, loaderData, params }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: `/merch/collections/${params.slug}`,
        title: loaderData.head.title,
        description: loaderData.head.description,
        noindex: loaderData.head.noindex,
      }),
      shopStyles,
    );
  },
  component: Collection,
});

function Collection() {
  return <ShopCollection collection={Route.useLoaderData()} />;
}
